import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EdlTooltipIcon } from '../enum/edl-tooltip-icon.enum';

@Component({
  selector: 'edl-tooltip',
  templateUrl: './edl-tooltip.component.html',
  styleUrls: ['./edl-tooltip.component.scss']
})
export class EdlTooltipComponent implements OnInit {
  @Input() help = "";
  @Input() icon: EdlTooltipIcon = EdlTooltipIcon.HELP;
  @Input() example = "";

  closeDelay = 1500;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  transform(html: string) {
    var outputHtml = this.sanitizer.bypassSecurityTrustStyle(html);
    return outputHtml;
  }

}
